import * as Icons from "lucide-react";
import { cn } from "@/lib/utils";
import { TRUST_BADGES } from "@/data/content";

export const TrustBadges = ({ tone = "light", className }) => {
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {TRUST_BADGES.map((b, i) => {
        const Icon = Icons[b.icon] || Icons.Check;
        return (
          <span
            key={b.label}
            data-testid={i === 0 ? "trust-badge-first" : undefined}
            className={cn(
              "inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold",
              tone === "navy"
                ? "border border-[color:rgba(231,190,74,0.28)] bg-[color:rgba(231,190,74,0.10)] text-[#F6D98A]"
                : "border border-[color:rgba(10,27,51,0.14)] bg-white text-[var(--ibp-ink)]"
            )}
          >
            <Icon className="h-3.5 w-3.5" aria-hidden="true" />
            {b.label}
          </span>
        );
      })}
    </div>
  );
};

export default TrustBadges;
